import React from 'react'
import './featured.css'

function Featured() {
  return (
     <div className="featured">
      <div className="featuredItem">
        <img
          src="https://thumbs.dreamstime.com/b/beautiful-amber-fort-jaipur-rajasthan-india-beautiful-amber-fort-jaipur-rajasthan-india-101086514.jpg"
          alt="Jaipur"
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Jaipur</h1>
          <h3>1556 properties</h3>
        </div>
      </div>
      
      <div className="featuredItem">
        <img
          src="https://thediplomat.com/wp-content/uploads/2015/03/sizes/td-story-s-2/thediplomat_2015-03-19_14-45-10.jpg"
          alt="Agra"
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>Agra</h1>
          <h3>414 properties</h3>
        </div>
      </div>
      <div className="featuredItem">
        <img
          src="https://images.hindustantimes.com/rf/image_size_630x354/HT/p2/2017/10/25/Pictures/_5dad3302-b959-11e7-83cc-689513d74e1b.jpg"
          alt="New Delhi"
          className="featuredImg"
        />
        <div className="featuredTitles">
          <h1>New Delhi</h1>
          <h3>2911 properties</h3>
        </div>
      </div>
    </div>
  )
}

export default Featured